<script>
export default {
  name:'BaseBanner2',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'A',
      validator(value) {
        return [
          'A',
          'B',
        ].includes(value)
      },
    },
    image: {
      type: String,
      // default: require('')
      default: ''
    }
  }
}
</script>
<!-- section template -->
<template>
  <section
    :class="[$style.baseBanner, $style[`isStyle${type}`], { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
    :style="{ backgroundImage: `url('${ image }')` }"
  >
    <h1
      :class="titleClass"
      class="baseBanner__title"
    >
      {{ title }}
    </h1>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.baseBanner {
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  overflow: hidden;
  background-color: rgba($color-primary, 10%);
  background-position: center;
  background-size: cover;

  @include max-md {
    height: 120px;
  }

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    content: "";
    background: rgba(#000, 0.25);
  }
  &.isStyleDingBeauty {
    &::before {
      background: rgba($color: #0C1C30, $alpha: 0.5);
    }
    :global {
      .baseBanner {
        &__title {
          font-weight: 400;
        }
      }
    }
  }

  :global {
    .baseBanner {
      &__title {
        margin-bottom: 0;
        font-family: $font-serif;
        font-size: 2rem;
        font-weight: 600;
        color: #fff;
        text-shadow: 0 3px 40px rgba(#000, 0.25);
        letter-spacing: 0.25rem;

        @include max-md {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
